import React from 'react';
import {RouteObject} from 'react-router';
import {GuestRoute} from '@common/auth/guards/guest-route';
import {LoginPageWrapper} from '@app/auth/login-page-wrapper';

// CUSTOM(albaniantheatre): overrides the foundation's /login routes with the
// Turnstile-enabled login page. Registered ahead of "authRoutes" in
// app-router.tsx; everything else in auth still comes from the foundation.
export const appAuthRoutes: RouteObject[] = [
  {
    path: '/login',
    element: (
      <GuestRoute>
        <LoginPageWrapper />
      </GuestRoute>
    ),
  },
  {
    path: '/workspace/join/login',
    element: (
      <GuestRoute>
        <LoginPageWrapper />
      </GuestRoute>
    ),
  },
];
